import React, { useState, ChangeEvent, useEffect } from 'react';
import { cn } from '@/lib/utils';
import FileIcon from '@repo/ui/components/icons/FileIcon';   
import { FormField, FormItem, FormLabel, FormMessage } from '@repo/ui';
import { useFormContext } from 'react-hook-form';
import CheckIcon from '@repo/ui/components/CheckIcon';



import type { FileUploadCardProps } from '../../types/component-props.types';
export default function FileUploadCard({
  name,
  error,
  className,
  label,
  initialFile,
  onUploadClick,
}: FileUploadCardProps) {
  const { control, setValue } = useFormContext();
  const [fileName, setFileName] = useState<string | null>(null);

  // Initialize fileName based on initialFile
  useEffect(() => {
    if (initialFile) {
      // Extract file name after "users/" from the URL
      const match = initialFile.match(/\/users\/(.+)$/);
      const extractedFileName = match ? match[1] : initialFile.split('/').pop()?.split('?')[0] || 'صورة_موجودة.jpg';
      setFileName(extractedFileName);
      setValue(name, initialFile, { shouldValidate: true }); // Set form value to URL
    } else {
      setFileName(null);
      setValue(name, undefined, { shouldValidate: true }); // Clear form value if no initial file
    }
  }, [initialFile, name, setValue]);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>, field: any) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
      field.onChange(file); // Set the File object in the form
      if (onUploadClick) onUploadClick();
    }
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn('space-y-2 w-full', className)}>
          <FormLabel className="text-primary-blue-900 font-medium text-[18px] leading-[33.73px] tracking-normal text-start">
            {label || 'صورة'}
          </FormLabel>
          <div className="flex justify-between bg-gray-50 border border-gray-300 rounded-md w-full ps-2">
            <div className="p-1 rounded-full border border-[#B6B5BF] w-fit my-[6px]">
              <CheckIcon className="w-5 h-5 text-[#B6B5BF]" />
            </div>
            <div className="flex gap-2">
              <div className="flex items-center gap-1">
                <span className="text-[#B6B5BF] text-sm flex-1 text-center">
                  {fileName || 'لا يوجد ملف محدد'}
                </span>
                <label className="flex items-center gap-2 cursor-pointer">
                  <FileIcon className="!w-6 !h-6 text-[#B6B5BF]" />
                  <input
                    type="file"
                    className="hidden"
                    onChange={(e) => handleFileChange(e, field)}
                    accept="image/jpeg,image/png,image/jpg,image/gif,image/svg+xml"
                  />
                </label>
              </div>
              <span className="text-[#B6B5BF] text-sm bg-[#E6E6E6] h-full px-3 flex items-center">
                رفع
              </span>
            </div>
          </div>
          <FormMessage>{error}</FormMessage>
        </FormItem>
      )}
    />
  );
}

